import React from 'react';
import './loader.css';

const Loader = ({ isLoading = true }) => {
    if (!isLoading) return null;

    return (
        <div className="loader-overlay">
            <div className="loader-spinner text-blue-500" style={{ animationDelay: '0s' }}></div>
            <div className="loader-spinner text-red-500" style={{ animationDelay: '0.2s' }}></div>
            <div className="loader-spinner text-green-500" style={{ animationDelay: '0.4s' }}></div>
        </div>
    );
};

export default Loader;
